import React from 'react';
import './LoadingSpinner.css';

/*LoadingSpinner: a component to design a loading spinner */
const LoadingSpinner = () => (
  <div className="loading"></div>
)

export default LoadingSpinner;